import { useSearchParams } from "@/lib/router";
import { SUPPORTED_LANGS } from "@/services/i18n/config";
import useAppStore from "@/store/app-store";
import { useTranslation } from "react-i18next";

const useAppTranslation = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { i18n } = useTranslation();

  // const appLang = useAppStore((state) => state.appLang);
  const setAppLang = useAppStore((state) => state.setAppLang);

  const activeLocale = i18n.resolvedLanguage;

  const getLocaleFromQueryString = () => {
    return searchParams.get("lang") || activeLocale;
  };

  const setLocale = (locale: string) => {
    if (!locale) return;
    const isSupported = SUPPORTED_LANGS[locale.toLowerCase()] || false;
    if (!isSupported) return;
    const normalizedLocale = locale.toLowerCase();
    i18n.changeLanguage(normalizedLocale);
    setAppLang(normalizedLocale);
  };

  return {
    activeLocale,
    getLocaleFromQueryString,
    setLocale,
  };
};

export default useAppTranslation;
